//removeIf(production)
import ExternalStatus from "../../enums/external-status";
import ClaroluzData from "../../domain/entities/claroluz-data";
import FloatWithTwoDecimals from "../../domain/entities/float-with-two-decimals";
import IClaroluzDataDatasource from "../../infra/datasources/i-claroluz-data-datasource";
import ClaroluzBill from "../../domain/entities/claroluz-bill";
import ClaroluzOffer from "../../domain/entities/claroluz-offer";
import ClaroluzPower from "../../domain/entities/claroluz-power";
import ClaroluzEnergy from "../../domain/entities/claroluz-energy";
import ClaroluzEvents from "../../infra/critical/claroluz-events";
import ClaroluzTopGas from "../../domain/entities/claroluz-top-gas";
import ClaroluzServiceLog from "../../infra/critical/claroluz-service-log";
import IClaroluzDatasourceEndpoints from "../../domain/usecases/i-claroluz-datasource-endpoints";
import ClaroluzCupsData from "../../domain/entities/claroluz-cups-data";
import UrlDataExtract from "../../domain/usecases/url-data-extract";
import TopGasAlert from "../../enums/top-gas-alert";
var apiData: IClaroluzDatasourceEndpoints;
//endRemoveIf(production)

class ClaroluzDataDatasource implements IClaroluzDataDatasource {
    url: IClaroluzDatasourceEndpoints = apiData;
    type: string;
    logData = {
        cups: '',
        value: ''
    };

    constructor(type: string) {
        this.type = type;
    }

    async getOffersByPdf(pdf: string, format: string): Promise<ClaroluzData> {
        let url = this.url.file;
        let method = 'POST';
        let body = JSON.stringify(pdf);
        let contentType = 'application/json-patch+json';

        console.log(pdf, body);

        return await this.doRequest(url, method, contentType, body);
    }

    async getOffersByUrl(data: string): Promise<ClaroluzData> {
        let url = this.url.qr;
        let method = 'POST';
        let contentType = 'application/json;';
        const billInfo = UrlDataExtract.of(data);

        let body = JSON.stringify(data);

        console.log(data, body);

        // this.logData = {
        //     cups: billInfo.cups,
        //     value: billInfo.price.value.toString()
        // };

        return await this.doRequest(url, method, contentType, body);
    }

    async getOffersByCups(data: ClaroluzCupsData): Promise<ClaroluzData> {
        let url = this.url.cups;
        let method = 'POST';
        let contentType = 'application/json';
        let body = JSON.stringify({
            cups: data.cups,
            amount: data.price.value.toString(),
            p1: data.options?.powerP1 ?? null,
            p2: data.options?.powerP2 ?? null,
            p3: data.options?.powerP3 ?? null,
            month: data.options?.month ?? null
        });

        this.logData = {
            cups: data.cups,
            value: data.price.value.toString()
        };

        return await this.doRequest(url, method, contentType, body);
    }

    private async doRequest(url: string, method: string, contentType: string, body?: any): Promise<any> {
        let status: ExternalStatus;
        let bill: ClaroluzBill | undefined = undefined;
        let log = new ClaroluzServiceLog();

        if (appProperties().debug) {
            let time = new Date().toLocaleTimeString();
            console.log(`[${time}] Requesting ${url}`);
        }

        let response = await fetch(url, {
            method: method,
            body: body ?? null,
            headers: {
                'Content-Type': contentType,
            }
        });

        log.setSendedData({
            type: this.type,
            cups: this.logData.cups,
            value: this.logData.value,
            api: {
                url: url,
                method: method,
                contentType: contentType,
            }
        });

        let result = await response.json();

        switch (response.status) {
            case 200:
                if (typeof result != 'undefined') {
                    if (typeof result.qrResponse != 'undefined') {
                        let topGas: ClaroluzTopGas;
                        let time = new Date().toLocaleTimeString();

                        if (result.qrResponse.isCUR === false && result.qrResponse.hasTopGas === false && result.qrResponse.isQr === false) {
                            if (appProperties().debug) {
                                console.log(`[${time}] %cisCUR: %c${result.qrResponse.isCUR} %chasTopGas: %c${result.qrResponse.hasTopGas} %cisQr: %c${result.qrResponse.isQr}`,
                                    'font-weight: bold;', 'font-weight: normal;',
                                    'font-weight: bold;', 'font-weight: normal;',
                                    'font-weight: bold;', 'font-weight: normal;',
                                );
                            }

                            topGas = new ClaroluzTopGas({
                                hasTopGas: result.qrResponse.hasTopGas,
                                hasAlert: true,
                                alert: TopGasAlert.NOT_PAYING,
                                value: result.qrResponse.totalTopGasPrice ? parseFloat(result.qrResponse.totalTopGasPrice) : 0,
                                offerValue: 0,
                            });
                        } else if (result.qrResponse.isCUR === false && result.qrResponse.hasTopGas === true && result.qrResponse.isQr === false && result.qrResponse.totalTopGasPrice > 0) {
                            if (appProperties().debug) {
                                console.log(`[${time}] %cisCUR: %c${result.qrResponse.isCUR} %chasTopGas: %c${result.qrResponse.hasTopGas} %cisQr: %c${result.qrResponse.isQr} %ctotalTopGasPrice: %c${result.qrResponse.totalTopGasPrice}`,
                                    'font-weight: bold;', 'font-weight: normal;',
                                    'font-weight: bold;', 'font-weight: normal;',
                                    'font-weight: bold;', 'font-weight: normal;',
                                    'font-weight: bold;', 'font-weight: normal;',
                                );
                            }
                            
                            topGas = new ClaroluzTopGas({
                                hasTopGas: result.qrResponse.hasTopGas,
                                hasAlert: true,
                                alert: TopGasAlert.PAYING,
                                value: result.qrResponse.totalTopGasPrice ? parseFloat(result.qrResponse.totalTopGasPrice) : 0,
                                offerValue: 0,
                            });
                        } else if (result.qrResponse.isCUR === true || result.qrResponse.isCUR === false && result.qrResponse.hasTopGas === false && result.qrResponse.isQr === true && result.qrResponse.finPen || result.qrResponse.isCUR === false && result.qrResponse.hasTopGas === true && result.qrResponse.totalTopGasPrice === 0) {
                            if (appProperties().debug) {
                                console.log(`[${time}] %cisCUR: %c${result.qrResponse.isCUR} %chasTopGas: %c${result.qrResponse.hasTopGas} %cisQr: %c${result.qrResponse.isQr} %cfinPen: %c${result.qrResponse.finPen} %ctotalTopGasPrice: %c${result.qrResponse.totalTopGasPrice}`,
                                    'font-weight: bold;', 'font-weight: normal;',
                                    'font-weight: bold;', 'font-weight: normal;',
                                    'font-weight: bold;', 'font-weight: normal;',
                                    'font-weight: bold;', 'font-weight: normal;',
                                    'font-weight: bold;', 'font-weight: normal;',
                                );
                            }
                            
                            topGas = new ClaroluzTopGas({
                                hasTopGas: result.qrResponse.hasTopGas,
                                hasAlert: true,
                                alert: TopGasAlert.PAYING_ESTIMATED,
                                value: result.qrResponse.totalTopGasPrice ? parseFloat(result.qrResponse.totalTopGasPrice) : 0,
                                offerValue: 0,
                            });
                        } else if (result.qrResponse.isCUR === false && result.qrResponse.hasTopGas === false && result.qrResponse.isQr === true && result.qrResponse.finPen === null) {
                            if (appProperties().debug) {
                                console.log(`[${time}] %cisCUR: %c${result.qrResponse.isCUR} %chasTopGas: %c${result.qrResponse.hasTopGas} %cisQr: %c${result.qrResponse.isQr} %cfinPen: %c${result.qrResponse.finPen}`,
                                    'font-weight: bold;', 'font-weight: normal;',
                                    'font-weight: bold;', 'font-weight: normal;',
                                    'font-weight: bold;', 'font-weight: normal;',
                                    'font-weight: bold;', 'font-weight: normal;',
                                );
                            }
                            
                            topGas = new ClaroluzTopGas({
                                hasTopGas: result.qrResponse.hasTopGas,
                                hasAlert: true,
                                alert: TopGasAlert.PAYING_NOT_IDENTIFIED,
                                value: result.qrResponse.totalTopGasPrice ? parseFloat(result.qrResponse.totalTopGasPrice) : 0,
                                offerValue: 0,
                            });
                        } else {
                            if (appProperties().debug) {
                                console.warn(`[${time}] ClaroluzTopGas default case`,
                                );
                            }

                            topGas = new ClaroluzTopGas({
                                hasTopGas: false,
                                hasAlert: false,
                                value: 0,
                                offerValue: 0,
                            });
                        }

                        bill = new ClaroluzBill({
                            cups: result.qrResponse.cups.replace(/\s/g, ''),
                            amount: parseFloat(result.qrResponse.imp),
                            is2TD: result.qrResponse.electricityFare === "2.0TD",
                            isPeninsula: true,
                            topGas: topGas,
                            yearlySave: result.qrResponse.yearlySave
                        });

                        let claroluzData = new ClaroluzData(ExternalStatus.CLAROLUZ_SUCCESS, bill);

                        if (typeof result.cupsOffers != 'undefined' && result.cupsOffers.length > 0) {
                            let isValidOffer = false;
                            let currentValue = bill.amount;
                            let hasOffers = !(bill.topGas.hasTopGas === false && bill.topGas.hasAlert === true);

                            result.cupsOffers.forEach((cupsOffer: {
                                roundedVatValue: number;
                                totalVatValue: number;
                                description: string;
                                shortDescription: string;
                                priceId: any;
                                roundedTotalWithVat: number;
                                electricityFareName: string;
                                offersGreenEnergy: boolean;
                                powerValueP1: number;
                                powerPriceP1: number;
                                intervalDays: number;
                                powerValueP2: number;
                                powerPriceP2: number;
                                roundedPowerTotal: number;
                                roundedEnergyValueP1: number;
                                roundedEnergyPriceP1: number;
                                roundedEnergyValueP2: number;
                                roundedEnergyPriceP2: number;
                                roundedEnergyValueP3: number;
                                roundedEnergyPriceP3: number;
                                vatValue: number;
                                roundedEnergyTotal: number;
                                roundedElectricalTax: number;
                                electricalTaxPercentage: number;
                                roundedMeasureDeviceRenting: number;
                                roundedTotal: number;
                                topGas: number;
                                environment: string; distributorName: string, distributorId: number;
                            }) => {
                                if (currentValue > cupsOffer.roundedTotalWithVat && hasOffers) {
                                    isValidOffer = true;

                                    claroluzData.addOffer(new ClaroluzOffer({
                                        distributor: cupsOffer.distributorName.toLowerCase().trim(),
                                        distributorId: cupsOffer.distributorId,
                                        is2TD: cupsOffer.electricityFareName === "2.0TD",
                                        offersGreenEnergy: cupsOffer.offersGreenEnergy,
                                        power1: new ClaroluzPower({
                                            value: cupsOffer.powerValueP1,
                                            price: cupsOffer.powerPriceP1,
                                            intervalDays: cupsOffer.intervalDays,
                                        }),
                                        power2: new ClaroluzPower({
                                            value: cupsOffer.powerValueP2,
                                            price: cupsOffer.powerPriceP2,
                                            intervalDays: cupsOffer.intervalDays,
                                        }),
                                        powerTotal: new ClaroluzPower({
                                            value: cupsOffer.roundedPowerTotal,
                                            price: 0.0,
                                            intervalDays: cupsOffer.intervalDays,
                                        }),
                                        energy1: new ClaroluzEnergy({
                                            value: cupsOffer.roundedEnergyValueP1,
                                            price: cupsOffer.roundedEnergyPriceP1
                                        }),
                                        energy2: cupsOffer.roundedEnergyValueP2 > 0 ? new ClaroluzEnergy({
                                            value: cupsOffer.roundedEnergyValueP2,
                                            price: cupsOffer.roundedEnergyPriceP2
                                        }) : null,
                                        energy3: cupsOffer.roundedEnergyValueP3 > 0 ? new ClaroluzEnergy({
                                            value: cupsOffer.roundedEnergyValueP3,
                                            price: cupsOffer.roundedEnergyPriceP3
                                        }) : null,
                                        vatValue: cupsOffer.vatValue,
                                        roundedVatValue: cupsOffer.roundedVatValue,
                                        totalVatValue: cupsOffer.totalVatValue,
                                        energyTotal: cupsOffer.roundedEnergyTotal,
                                        electricalTax: cupsOffer.roundedElectricalTax,
                                        electricalTaxPercentage: cupsOffer.electricalTaxPercentage,
                                        measureDeviceRenting: cupsOffer.roundedMeasureDeviceRenting,
                                        priceTotal: cupsOffer.roundedTotal,
                                        priceTotalWithVat: cupsOffer.roundedTotalWithVat,
                                        priceId: parseInt(cupsOffer.priceId),
                                        description: cupsOffer.description,
                                        shortDescription: cupsOffer.shortDescription,
                                    }));

                                    if (bill!.topGas.hasTopGas) {
                                        bill!.topGas.offerValue = cupsOffer.topGas;
                                    }
                                }
                            });

                            if (!isValidOffer) {
                                claroluzData.status = ExternalStatus.CLAROLUZ_NO_OFFERS;
                            }
                        } else {
                            claroluzData.status = ExternalStatus.CLAROLUZ_NO_OFFERS;
                        }

                        log.setReceivedData({
                            status: claroluzData.status == ExternalStatus.CLAROLUZ_SUCCESS ? 'success' : 'no_offers',
                            response: result,
                        });
                        log.register();

                        return claroluzData;
                    } else {
                        new ClaroluzEvents(appProperties(), 'datasource', 'result', 'unknown-error', response);
                        status = ExternalStatus.CLAROLUZ_UNKNOWN_ERROR;
                    }
                } else {
                    new ClaroluzEvents(appProperties(), 'datasource', 'result', 'unknown-error', response);
                    status = ExternalStatus.CLAROLUZ_UNKNOWN_ERROR;
                }
                break;
            case 404:
                status = ExternalStatus.NOT_FOUND;
                break;
            case 400:
                status = ExternalStatus.BAD_REQUEST;
                break;
            case 401:
                status = ExternalStatus.UNAUTHORIZED;
                break;
            case 403:
                status = ExternalStatus.FORBIDDEN;
                break;
            case 408:
                status = ExternalStatus.GATEWAY_TIMEOUT;
                break;
            case 500:
                status = ExternalStatus.INTERNAL_SERVER_ERROR;
                break;
            case 503:
                status = ExternalStatus.SERVICE_UNAVAILABLE;
                break;
            default:
                status = ExternalStatus.CLAROLUZ_UNKNOWN_ERROR;
                break;
        }

        log.setReceivedData({
            status: status,
            response: result,
        });
        log.register();

        return new ClaroluzData(status, bill);
    }

}

//removeIf(production)
export default ClaroluzDataDatasource;

function appProperties(): import("../../infra/critical/claroluz-events-properties").default {
    throw new Error("Function not implemented.");
}
//endRemoveIf(production)